import { PatternData } from "../../../types/types";
import {
  discountBox,
  small,
  logoHead,
  discountValue,
} from "./DiscountTag.module.css";
import { StaticImage } from "gatsby-plugin-image";

interface DiscountTagProps {
  pattern: PatternData;
  size?: "default" | "small";
}

const DiscountTag = ({ pattern, size = "default" }: DiscountTagProps) => {
  return (
    <div
      className={`${discountBox} ${size === "small" ? small : ""}`}
      data-cy="discount-tag"
    >
      <StaticImage
        src={"../../../images/png/logoHead.png"}
        alt="Crocheniacs' logo"
        placeholder="blurred"
        className={`${logoHead} ${size === "small" ? small : ""}`}
      />
      <div className={`${discountValue} ${size === "small" ? small : ""}`}>
        {pattern.adjustmentAmount}% off
      </div>
    </div>
  );
};

export default DiscountTag;
